
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa5f53908a3c18895266e586b85c42a09en from './en.yaml'
            i18n.addResourceBundle('en', 'a5f53908a3c18895266e586b85c42a09', flattenObject(nsa5f53908a3c18895266e586b85c42a09en), true, true);
        
        export default 'a5f53908a3c18895266e586b85c42a09';
    